<template lang="html">
  <nav
    class="app-bottom-nav fixed inset-x-0 bottom-0 z-40 border-t border-default bg-default lg:hidden"
    style="padding-bottom: env(safe-area-inset-bottom, 0px)"
    aria-label="Основная навигация"
  >
    <!-- `as="div"`: Reka NavigationMenuRoot hardcodes aria-label="Main"; avoid nested <nav>. -->
    <UNavigationMenu
      as="div"
      :items="items"
      variant="link"
      color="primary"
      class="w-full"
      :ui="{
        root: 'w-full gap-0 px-0.5 [&>div]:min-w-0 [&>div:first-child]:w-full',
        list: 'w-full gap-0',
        item: 'flex-1 basis-0 min-w-0 py-0',
        link: 'relative flex-col gap-0.5 px-0.5 pt-1.5 pb-1 text-[10px] leading-tight justify-center items-center min-w-0 font-medium',
        linkLeadingIcon: 'size-5',
        linkLabel: 'max-w-full truncate text-center',
        linkTrailing: 'absolute top-0.5 end-1 ms-0',
        linkTrailingBadge: 'min-w-4 justify-center px-1 text-[9px]',
      }"
    />
  </nav>
</template>

<script lang="ts" setup>
import type { NavigationMenuItem } from '@nuxt/ui'

const route = useRoute()
const { openAuth } = useAuthInteractive()
const { store: authStore } = useAuth()
const { store: cartStore, routing: cartRouting } = useCartModule()

const isFullAuth = computed(() => !!authStore.token && !authStore.session?.isAnon)

const isCatalogActive = computed(() =>
  route.path === '/catalog' || route.path.startsWith('/catalog/'),
)

const isFavoritesActive = computed(
  () => route.path === '/profile/favorites' || route.path.startsWith('/profile/favorites/'),
)

const isCartActive = computed(
  () => route.name === 'CartIndex' || route.path === '/cart' || route.path.startsWith('/cart/'),
)

const isProfileActive = computed(
  () => route.path.startsWith('/profile') && !isFavoritesActive.value,
)

const authItem = computed<NavigationMenuItem>(() => {
  if (isFullAuth.value) {
    return {
      label: 'Профиль',
      icon: 'i-lucide-user',
      to: '/profile',
      active: isProfileActive.value,
    }
  }

  return {
    label: 'Войти',
    icon: 'i-lucide-user',
    onSelect: () => {
      openAuth()
    },
  }
})

const items = computed<NavigationMenuItem[]>(() => [
  {
    label: 'Главная',
    icon: 'i-lucide-home',
    to: '/',
    active: route.path === '/',
  },
  {
    label: 'Каталог',
    icon: 'i-lucide-layout-grid',
    to: '/catalog',
    active: isCatalogActive.value,
  },
  {
    label: 'Корзина',
    icon: 'i-lucide-shopping-cart',
    to: cartRouting.index.route,
    active: isCartActive.value,
    ...(cartStore.totalLength
      ? { badge: String(cartStore.totalLength) }
      : {}),
  },
  {
    label: 'Избранное',
    icon: 'i-lucide-heart',
    to: '/profile/favorites',
    active: isFavoritesActive.value,
  },
  authItem.value,
])
</script>
